import "./searchInputFilterStyles.scss";

export interface SearchFilterProps {
  placeHolder: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  style?: React.CSSProperties;
}
export const SearchInputFilter = (props: SearchFilterProps) => {
  return (
    <div className="flex-col searchFilter" style={props.style}>
      <input
        onChange={props.onChange}
        className="text-normal text-small primary-color-35 searchFilter"
        type="text"
        placeholder={props.placeHolder}
        style={{
          textAlign: "center",
          background: "rgba(255,255,255,0.2)",
          borderRadius: "8px",
          border: "none",
          height: "28px",
        }}
      />
    </div>
  );
};
